// React
import { CSSProperties, ReactElement } from 'react';
// Utils
import { rem } from '@utmb/utils/font';
// Styles
import styles from './my-table.module.scss';

interface MyTableProps {
    children: any;
    className?: string;
    rowSpacing?: number;
    isLoading?: boolean;
}

export const MyTable = (props: MyTableProps): ReactElement => {
    const { children, className, rowSpacing, isLoading } = props;

    // Define the CSS properties
    const style: CSSProperties = {};

    if (rowSpacing) style.rowGap = rem(rowSpacing);

    // Define the CSS classes
    const classesCSS = [className, styles.container, isLoading && styles.is_loading].filter(Boolean).join(' ');

    return (
        <div className={classesCSS} style={style}>
            {children}
        </div>
    );
};
